import { format } from "date-fns";

export const getUniqueSessionDates = (sessions = []) => {
    return Array.from(
        new Set(
            sessions
                .filter((s) => s?.session_date && !isNaN(new Date(s.session_date)))
                .map((s) => format(new Date(s.session_date), "yyyy-MM-dd"))
        )
    ).sort((a, b) => new Date(a) - new Date(b));
};
